<div class="order-cancel">
  <div class="order-cancel__header">
    <span class="order-cancel__header__title">Anular pedido</span>
    <button mat-icon-button (click)="dialogRef.close()" data-testid="cancel-dialog-close-btn">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="order-cancel__container">
    @if (state.hasError()) {
    <div class="order-cancel__message">
      <app-horus-message-general
        nameIcon="errorMessageIcon"
        btnAction="INTENTAR NUEVAMENTE"
        (action)="retryFetchCancellationTypes()"
      >
        <span style="color: #f14b26; font-size: 14px; line-height: 25px"
          >Lo sentimos</span
        ><br />
        Hubo un <strong>error al intentar cargar</strong> las opciones de
        anulación.
      </app-horus-message-general>
    </div>
    } @else if (state.isLoaded() && state.isAllowedToCancel()) {
    <form [formGroup]="orderCancelForm" class="order-cancel__body">
      <div class="order-cancel__body__info">
        <span>{{ data.orderId }}</span>
      </div>
      <div class="order-cancel__body__payment">
        <div class="payment">
          <div class="payment__box">
            <div class="payment__box__title">medio de pago</div>
            <div class="payment__box__value">
              <div *ngIf="paymentData.showName" class="name">
                {{ paymentData.name }}
              </div>
              <div class="icon">
                <img [src]="paymentData.iconUrl" alt="" />
              </div>
            </div>
          </div>
          <div class="payment__box">
            <div class="payment__box__title">Monto a reembolsar</div>
            <div class="payment__box__value">
              S/ {{ data.total | number : "1.2-2" }}
            </div>
          </div>
        </div>
        <mat-form-field
          appearance="outline"
          hideRequiredMarker
          class="mat-form-select-orders-panel"
        >
          <mat-label>Motivo de cancelación</mat-label>
          <mat-select
            data-testid="order-detail-body-select-orders"
            formControlName="cancellationType"
            #matSelectOrders
          >
            @for (cancellationType of state.cancellationTypes(); track
            cancellationType.code) {
            <mat-option
              [attr.data-testid]="'order-detail-header-option-' + data.orderId"
              [value]="cancellationType.code"
            >
              {{ cancellationType.descripcion }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </form>
    <div class="order-cancel__footer">
      <div class="order-cancel__footer__options">
        <button
          horusBtn
          [disabled]="orderCancelForm.invalid"
          (click)="openConfirmOrderCancellation()"
          data-testid="cancel-dialog-submit-btn"
        >
          ANULAR PEDIDO
        </button>
        <button
          horusBtn
          horusBtnVariant="outline-default"
          (click)="dialogRef.close()"
          data-testid="cancel-dialog-cancel-btn"
        >
          CANCELAR
        </button>
      </div>
    </div>
    } @else if (state.isLoaded() && !state.isAllowedToCancel()) {
    <div class="order-cancel__message">
      <app-horus-message-general
        nameIcon="noDataMessageIcon"
        btnAction="INGRESAR TICKET"
        (action)="redirectToAria()"
      >
        <span style="color: #f6d44d; font-size: 14px; line-height: 25px"
          >No podemos ejecutar la acción</span
        ><br />
        <span style="font-weight: 400"
          >Este pedido
          <strong>no cumple las condiciones para ser anulado</strong> .</span
        >
      </app-horus-message-general>
    </div>
    } @else {
    <div class="order-cancel__message order-cancel__message--loading" data-testid="cancel-dialog-loading">
      <app-horus-loading size="S"></app-horus-loading>
    </div>
    }
  </div>
</div>

<ng-template #confirmTemplate let-close="close">
  @if (state.cancelOrderMutation.result$ | async; as mutationState) {
    @if (mutationState.isPending) {
      <app-horus-loading></app-horus-loading>
    } @else if (mutationState.isSuccess) {
      @if (mutationState.data!.code === 1) {
        <app-horus-message-general
          nameIcon="successMessageIcon"
          btnAction="ACEPTAR"
          size="M"
          (action)="closeAllDialogs()">
          <p class="title-ok">¡Listo!</p>
          <div class="message">
            Anulaste el pedido de <br />
            manera correcta.
          </div>
        </app-horus-message-general>
      } @else if (mutationState.data!.code === 2) {
        <app-horus-message-general
          nameIcon="noDataMessageIcon"
          btnAction="INGRESAR TICKET"
          btnCancel="CANCELAR"
          size="M"
          (action)="redirectToAria()"
          (actionCancel)="close()">
          <span style="color: #f6d44d; font-size: 16px; line-height: 25px">
            No podemos ejecutar la acción
          </span><br />
          <p class="text-[18px]!" style="font-size: 18px; font-weight: normal; line-height: 24px">
            Este pedido ya no puede ser anulado. Sí aún deseas continuar con este
            proceso, ingresa un ticket.
          </p>
        </app-horus-message-general>
      } @else {
        <app-horus-message-general
          nameIcon="errorMessageIcon"
          btnAction="INTENTAR NUEVAMENTE"
          (action)="reintentCancelOrder()"
          btnCancel="CANCELAR"
          (actionCancel)="close()">
          <span style="color: #f14b26; font-size: 14px; line-height: 25px">
            Lo sentimos
          </span><br />
          <p style="font-size: 18px !important; font-weight: normal"
             class="max-w-[280px] text-[18px]! mx-auto">
            {{ mutationState.data!.message || 'Hubo un error al intentar anular el pedido.' }}
          </p>
        </app-horus-message-general>
      }
    } @else if (mutationState.isError) {
      <app-horus-message-general
        nameIcon="errorMessageIcon"
        btnAction="INTENTAR NUEVAMENTE"
        (action)="reintentCancelOrder()"
        btnCancel="CANCELAR"
        (actionCancel)="close()">
        <span style="color: #f14b26; font-size: 14px; line-height: 25px">
          Lo sentimos
        </span><br />
        <p style="font-size: 18px !important; font-weight: normal"
           class="max-w-[280px] text-[18px]! mx-auto">
          Hubo un error de red al intentar anular el pedido.
        </p>
      </app-horus-message-general>
    } @else {
      <div class="confirm__body">
        <div class="confirm__body__icon">
          <mat-icon svgIcon="iconCar"></mat-icon>
        </div>
        <div class="confirm__body__message">
          <span>Estás a punto de anular este pedido.</span>
          <span>¿Quieres confirmar la <strong>anulación</strong>?</span>
        </div>
        <div class="confirm__body__actions">
          <button
            horusBtn
            horusBtnVariant="outline-default"
            horusBtnSize="md"
            (click)="close()">
            CANCELAR
          </button>
          <button horusBtn horusBtnSize="md" (click)="onConfirmOrderCancellation()">
            CONFIRMAR
          </button>
        </div>
      </div>
    }
  } @else {
    <div class="confirm__body">
      <div class="confirm__body__icon">
        <mat-icon svgIcon="iconCar"></mat-icon>
      </div>
      <div class="confirm__body__message">
        <span>Estás a punto de anular este pedido.</span>
        <span>¿Quieres confirmar la <strong>anulación</strong>?</span>
      </div>
      <div class="confirm__body__actions">
        <button
          horusBtn
          horusBtnVariant="outline-default"
          horusBtnSize="md"
          (click)="close()">
          CANCELAR
        </button>
        <button horusBtn horusBtnSize="md" (click)="onConfirmOrderCancellation()">
          CONFIRMAR
        </button>
      </div>
    </div>
  }
</ng-template>
